'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
require('../../../../../aviary-core/dist/cjs/index.cjs');
var aviaryTokens = require('aviary-tokens');
var Pill_web = require('../../atoms/Pill/Pill.web.cjs');
var Tooltip_web = require('../../atoms/Tooltip/Tooltip.web.cjs');
var reactFontawesome = require('../../../react-fontawesome/react-fontawesome.cjs');
var AvailabilityStatusPill_web_styles = require('./AvailabilityStatusPill.web.styles.cjs');
var index = require('../../../../../../_virtual/index.cjs');

/**
 * Pill or icon to display the availability status of a product or service.
 *
 * @scope Core
 */ const AvailabilityStatusPill = ({ availabilityStatus, tooltipContent, size, pillStyles, customCss, ...rest })=>{
    const { availabilityLabelText, availabilityStatusIcon } = index.__exports.getProductAvailabilityLabel(availabilityStatus);
    const currentTheme = react.useTheme();
    const themeColors = aviaryTokens.colorProfileMapper(currentTheme);
    if (!availabilityLabelText) {
        return null;
    }
    const getBackgroundColor = ()=>{
        switch(availabilityStatus){
            case "Discontinued":
            case "Unavailable":
            case "n/a":
                return "danger";
            case "Backordered":
                return "warning";
            case "To be discontinued":
                return "system";
            default:
                return "system";
        }
    };
    if (size !== "xxsmall") {
        return /*#__PURE__*/ jsxRuntime.jsx(Pill_web.Pill, {
            labelContent: availabilityLabelText,
            backgroundColor: getBackgroundColor(),
            size: size,
            icon: availabilityStatusIcon,
            tooltipContent: tooltipContent,
            customCss: [
                pillStyles,
                customCss
            ],
            ...rest
        });
    }
    return /*#__PURE__*/ jsxRuntime.jsx(Tooltip_web.Tooltip, {
        tooltipContent: `${availabilityLabelText}. ${tooltipContent}`,
        isTooltipHidden: tooltipContent === "",
        children: availabilityStatusIcon && /*#__PURE__*/ jsxRuntime.jsx(reactFontawesome.FontAwesomeIcon, {
            icon: availabilityStatusIcon,
            title: availabilityLabelText,
            "aria-label": availabilityLabelText,
            css: [
                AvailabilityStatusPill_web_styles.icon.base,
                AvailabilityStatusPill_web_styles.icon.intention(themeColors[getBackgroundColor()]),
                customCss
            ],
            ...rest
        })
    });
};

exports.AvailabilityStatusPill = AvailabilityStatusPill;
//# sourceMappingURL=AvailabilityStatusPill.web.cjs.map
